<template>
  <transition name="fade"><div class="absolute top-0 right-0 bottom-0 left-0 z-20 py-6 px-8" v-if="open" @click.self="open = false">
    <div @click.self="open = false" id="behind-modal" class="absolute right-0 left-0 z-20 bg-black opacity-50"></div>
    <div :class="[c.border500]" id="modal" class="shadow-2xl max-w-xs py-6 text-gray-800 rounded-lg relative w-full h-auto bg-white z-30 m-auto">
      <div class="mt-3 absolute top-0 right-0 cursor-pointer" @click="open = false"><svg class="w-5 m-4" fill="#a0aec0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"/></svg></div>
      <div class="hidden sm:block mt-1 mx-6 uppercase tracking-wide text-gray-600 font-bold text-sm">Name</div>
      <div class="leading-tight mx-6 mt-1 first-letter-upper text-lg font-bold">{{ item.itemData.sname || item.itemData.name }}</div>
      <div v-if="item.itemData.sname" class="break-words first-letter-upper px-6 mt-1">{{ item.itemData.name }}</div>
      <HistamineScore :itemData="this.item.itemData" :c="c" />
      <div class="px-6 mt-5 uppercase tracking-wide text-gray-600 font-bold text-sm">Extra information</div>
      <div class="px-6 mt-1 break-words">{{ item.itemData.note || 'No extra info' }}</div>
    </div>
  </div></transition>
</template>

<script>
import HistamineScore from "@/components/HistamineScore.vue";

export default {
  components: {
    HistamineScore
  },
  data() {
    return {
      open: false,
      item: {}
    };
  },
  computed: {
    c() {
      let cols = {
        "0": {
          border500: "border-green-500",
          bg200: "bg-green-200",
          bg100: "bg-green-100",
          text700: "text-green-700",
          text800: "text-green-800",
          text900: "text-green-900"
        },
        "1": {
          border500: "border-yellow-500",
          bg200: "bg-yellow-200",
          bg100: "bg-yellow-100",
          text700: "text-yellow-700",
          text800: "text-yellow-800",
          text900: "text-yellow-900"
        },
        "2": {
          border500: "border-orange-500",
          bg200: "bg-orange-200",
          bg100: "bg-orange-100",
          text700: "text-orange-700",
          text800: "text-orange-800",
          text900: "text-orange-900"
        },
        "3": {
          border500: "border-red-500",
          bg200: "bg-red-200",
          bg100: "bg-red-100",
          text700: "text-red-700",
          text800: "text-red-800",
          text900: "text-red-900"
        },
        "?": {
          border500: "border-gray-500",
          bg200: "bg-gray-200",
          bg100: "bg-gray-100",
          text700: "text-gray-700",
          text800: "text-gray-800",
          text900: "text-gray-900"
        }
      };
      return cols[this.item.itemData.sco];
    }
  },
  mounted() {
    this.$root.$on("openModal", val => {
      this.item = val;
      this.open = true;
    })
  },
  methods: {
    doThis() {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#modal{
  max-height: 100%;
  overflow-y: auto;
  border-top-width: 5px;
}

#behind-modal{
  top: -100px;
  bottom: -100px;
}

.text-4-5xl {
  font-size: 40px;
}

.border-6 {
  border-width: 6px;
}

.border-t-6 {
  border-top-width: 6px;
}

.line-height-50 {
  line-height: 52px;
}

.fade-leave-active {
  transition: opacity .15s ease-in;
	animation: page-out 0.15s ease-in both;
  transform: translate3d(0,0,0);
}
.fade-enter-active{
  transition: opacity .15s ease-out;
  animation: page-in 0.15s 0.15s ease-out both;
  transform: translate3d(0,0,0);
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}




@keyframes page-out {
    0% {
        transform: translateY(0);
        transform-origin: 50% 0%;
        opacity: 1;
    }
    100% {
        transform: translateY(20px);
        transform-origin: 50% 0%;
        opacity: 0;
    }
}


@keyframes page-in {
    0% {
        transform: translateY(-20px);
        transform-origin: 50% 0%;
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        transform-origin: 50% 0%;
        opacity: 1;
    }
}


</style>
